import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import BMI from "../../Assets/Projects/BMI.jpg";
import emotion from "../../Assets/Projects/catch.jpg";
import editor from "../../Assets/Projects/solar.gif";
import chatify from "../../Assets/Projects/Tetris.gif";
import suicide from "../../Assets/Projects/drawing.jpg";
import bitsOfCode from "../../Assets/Projects/Ping-Pong.gif";
import DVS from "../../Assets/Projects/o1.png";
import grub from "../../Assets/Projects/grub.jpg";
import nac from "../../Assets/Projects/nac.jpg";
import notepad from "../../Assets/Projects/notepad.jpg";
import clock from "../../Assets/Projects/clock.jpg";
import snake from "../../Assets/Projects/snake.jpeg";
import stick from "../../Assets/Projects/stick.jpg";
import rss from "../../Assets/Projects/rss.jpg";
import tdl from "../../Assets/Projects/todolist.jpg";
import cal from "../../Assets/Projects/Calculator.png";
import space from "../../Assets/Projects/gameplay.gif";
import gest from "../../Assets/Projects/gest.jpeg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent Works
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={DVS}
              isBlog={false}
              title="Dice Game"
              description="Dice Game, is a standalone multiplayer game created using MATLAB App and Python. Each player will roll the dice and player having bigger number in each roll will get a chance to perform action of choice (heal action or attack action)."
              ghLink="https://github.com/hemangsharma/B.Tech"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Tetris"
              description="A copy of Orginal Tetris game, created using Python."
              ghLink="https://github.com/hemangsharma/Tetris"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={space}
              isBlog={false}
              title="Space Invasion"
              description="Space Invaders is a shoot 'em up arcade game developed by Hemang using Python"
              ghLink="https://github.com/hemangsharma/spaceinvasion"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gest}
              isBlog={false}
              title="Gesture Controller for Video Player"
              description="Gesture control is a breakthrough feature that give you full control of your devices, with just your hand gestures. It’s a whole new way of interacting with your device."
              ghLink="https://github.com/hemangsharma/Gestured-control-for-video-player"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Ping Pong"
              description="A simple Ping Pong game created using Python Programming Language."
              ghLink="https://github.com/hemangsharma/PingPong-Classic"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={BMI}
              isBlog={false}
              title="BMI"
              description="BMI app created using Swift language for macOS "
              ghLink="https://github.com/hemangsharma/BMI-Calculator"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Drawing"
              description="Drawing is an app which can be used to draw on iPhone & iPad. Sketchbook allows user to save the drawing in their photo library and users can also use Apple Pencil to draw on iPad."
              ghLink="https://github.com/hemangsharma/Sketchbook"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Catch Me Ar"
              description="AR based game developed using Swift Programming Language"
              ghLink="https://github.com/hemangsharma/Catch-Me-AR"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={grub}
              isBlog={false}
              title="Grub"
              description="A Simple Search Enginer for Wikipedia created using Python Programming Language."
              ghLink="https://github.com/hemangsharma/GRUB"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={snake}
              isBlog={false}
              title="Snakes"
              description="Snakes game created using Swift"
              ghLink="https://github.com/hemangsharma/Snakes" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={stick}
              isBlog={false}
              title="Stick Ninja"
              description="Stretch the stick in order to reach and walk on the platforms. Watch out! if the stick is not long enough, you will fall down! Let's see how far can you go?"
              ghLink="https://github.com/hemangsharma/Stick-Ninja" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nac}
              isBlog={false}
              title="Noughts-And-Crosses"
              description="A simple game of Noughts-And-Crosses created using SWIFT"
              ghLink="https://github.com/hemangsharma/Noughts-And-Crosses" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={notepad}
              isBlog={false}
              title="NotePad"
              description="NotePad created using Python"
              ghLink="https://github.com/hemangsharma/notepad" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rss}
              isBlog={false}
              title="RSS FeedParser"
              description="A RSS Feed Parser created using Tkinter"
              ghLink="https://github.com/hemangsharma/RSSFeedParser" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={clock}
              isBlog={false}
              title="Clock"
              description="A digital clock made using python language (Tkinter)"
              ghLink="https://github.com/hemangsharma/Python-Clock"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tdl}
              isBlog={false}
              title="ToDoList"
              description="A GUI based 'To Do List' created using SWIFT"
              ghLink="https://github.com/hemangsharma/To-Do-List"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cal}
              isBlog={false}
              title="Calculator"
              description="A GUI calculator created using Python"
              ghLink="https://github.com/hemangsharma/Calculator/" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="SolAr"
              description="A SWIFT based AR app to experience Solar System"
              ghLink="#"             
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
